import { useQuery } from '@apollo/client';
import { GET_CLIENT_REPORT_TOKEN } from '@pass-frontend/common/data-access';
import { TrustedToken } from '@pass-frontend/data-access/common/edge';

export const useClientReportToken = (clientName: string) => {
  const { loading, error, data } = useQuery<{
    reportToken: Pick<TrustedToken, 'token'>;
  }>(GET_CLIENT_REPORT_TOKEN, {
    ssr: false, // SKIP ON SSR COMPLETELY
    fetchPolicy: 'no-cache',
    variables: {
      clientName: clientName,
    },
  });

  const { reportToken } = data || {};

  return {
    loading: loading || false,
    error: error || false,
    token: reportToken?.token || undefined,
  };
};
